<template>
  <div class="form-group">
    <label :for="id" class="form-label">{{ label }}</label>
    <input
      :id="id"
      type="password"
      class="form-control"
      :placeholder="placeholder"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <slot name="validation"></slot>
  </div>
</template>
<script>
export default {
  props: {
    id: String,
    label: String,
    modelValue: null,
    placeholder: String
  },
};
</script>
